// components/NoConsentsFound.js
import React from 'react';
import Button from './common/Button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const NoConsentsFound = ({ customDetails, onOkay, isLogout }) => {
	const history=useHistory();
	
	const handleClick = () =>{
		setTimeout(()=>{
			history.push("/");
			window.location.reload(); 
		},1000)
	}

	return (
		<div className="col-12">
			<div className="row py-5 px-3">
				<div className="col-lg-12 col-12">
					<h1
						className="fs-20 fw-600 text-center mb-4"
						style={{
							color: customDetails?.headingColor,
							fontFamily: customDetails?.fontFamily,
						}}
					>
						No consents found
					</h1>
					<p
						className="fs-14 fw-500 text-start mt-2 mb-4"
						style={{
							color: customDetails?.textColor,
							fontFamily: customDetails?.fontFamily,
						}}
					>
						We could not find active or paused consents, and could be due to either:
					</p>
					<ul className="mt-2">
						<li
							className="fs-15 fw-500 text-start mb-2"
							style={{
								color: customDetails?.headingColor,
								fontFamily: customDetails?.fontFamily,
								fontSize: '14px',
							}}
						>
							You have already revoked all consents
						</li>
						<li
							className="fs-15 fw-500 text-start"
							style={{
								color: customDetails?.headingColor,
								fontFamily: customDetails?.fontFamily,
								fontSize: '14px',
							}}
						>
							You have not provided any consent
						</li>
					</ul>
				</div>
				<div
					className="col-12 mt-5"
					style={{ display: 'flex', justifyContent: 'center' }}
				>
					<Button
						text="Logout"
						onClick={handleClick}
						style={{
							height: customDetails?.btnHeight,
							width: customDetails?.btnWidth,
							borderRadius: customDetails?.borderRadius,
							backgroundColor: customDetails?.primaryColor,
							display: 'flex',
							fontFamily: customDetails?.fontFamily,
							justifyContent: 'center',
						}}
					/>
				</div>
				{isLogout && (
					<p className="fs-14 fw-600 text-danger mt-5">
						You are logged out. You may close this window
					</p>
				)}
			</div>
		</div>
	);
};

export default NoConsentsFound;